import { Directive, HostListener, Input, NgZone } from '@angular/core';
import { UntypedFormControl, AbstractControl, UntypedFormGroup, UntypedFormArray } from '@angular/forms';

import { CmsAnalyticsService } from 'idt-analytics-api/cms-analytics.service';
import { AnalyticsComponentEvent } from 'idt-analytics-api/models';


@Directive({
  selector: '[analyticsEvents]'
})
export class AnalyticsEventsDirective {

  @Input() public analyticsEventClick: string | undefined;
  @Input() public analyticsEventHover: string | undefined;
  @Input() public analyticsEventBlur: string | undefined;
  @Input() public analyticsEventData: AnalyticsComponentEvent | undefined;
  @Input() public analyticsFormControl: UntypedFormControl | UntypedFormArray | UntypedFormGroup | undefined;

  constructor(
    private readonly trackService: CmsAnalyticsService,
    private readonly ngZone: NgZone
  ) {}

  @HostListener('click', ['$event'])
  public click() {
    if (this.analyticsEventClick) {
      this.ngZone.runOutsideAngular(() => {
        this.trackService.track(this.analyticsEventClick!, this.analyticsEventData || {});
      });
    }
  }

  @HostListener('mouseover', ['$event'])
  public hover() {
    if (this.analyticsEventHover) {
      this.ngZone.runOutsideAngular(() => {
        this.trackService.track(this.analyticsEventHover!, this.analyticsEventData || {});
      });
    }
  }

  @HostListener('blur', ['$event'])
  public blur() {
    if (isDefined(this.analyticsEventBlur) && isDefined(this.analyticsFormControl) && !this.analyticsFormControl.valid) {
      this.ngZone.runOutsideAngular(() => {
        this.trackService.track(this.analyticsEventBlur!, { field: this.getControlName(this.analyticsFormControl!) });
      });
    }
  }

  private getControlName(control: UntypedFormControl | UntypedFormArray | UntypedFormGroup): string | undefined {
    const formGroup = control.parent!.controls as Record<string, AbstractControl>;
    return Object.keys(formGroup).find((name) => control === formGroup[name]);
  }

}
